import { styled } from "@linaria/react"
import { debounce } from "lodash-es"
import { useEffect, useMemo } from "react"

import { Horizontal } from "@/components/Flex.ts"

import type { ReactNode, RefAttributes, RefObject } from "react"


type DropdownFilterInputProps = RefAttributes<HTMLInputElement> & {
  setInputValue: (value: string) => void
  beforeInput?: ReactNode
}

export const DropdownFilterInput = ({ ref, ...props }: DropdownFilterInputProps) => {
  const debouncedInput = useMemo(
    () =>
      debounce(props.setInputValue, 100, {
        leading: true,
        trailing: true,
      }),
    [props.setInputValue]
  )

  useEffect(() => {
    (ref as RefObject<HTMLInputElement>).current.focus()
  })

  return (
    <FilterInputContainer>
      {props.beforeInput}
      <FilterInput
        autoFocus
        type="text"
        placeholder="Type to search"
        onChange={(e) => debouncedInput(e.target.value)}
        ref={ref}
      />
    </FilterInputContainer>
  )
}

const FilterInputContainer = styled(Horizontal)`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`

const FilterInput = styled.input`
  appearance: none;
  background: none;
  outline: none;
  border: none;

  height: 24px;
  flex: 1;
`
